import React from "react"
import { Grid } from "@mui/material"

import {UserSettingsAcrissTabButton, UserSettingsAcrissTable, UserSettingAcrissDrawer} from "./Acriss"
import {UserSettingCategoryDrawer, UserSettingsCategoryTabButton, UserSettingsCategoryTable} from "./Category"


export default function UserSettingsItemsTab() {
    return <Grid container spacing={1}>
		<Grid item xs={6} sx={{  display: 'flex', justifyContent: "flex-end"  }}>
			<UserSettingsAcrissTabButton />
		</Grid>

		<Grid item xs={6} sx={{  display: 'flex', justifyContent: "flex-end"  }}>
			<UserSettingsCategoryTabButton />
		</Grid>

		<Grid item xs={6}>
			<UserSettingsAcrissTable />
		</Grid>

		<Grid item xs={6}>
			<UserSettingsCategoryTable />
		</Grid>

		<UserSettingAcrissDrawer />
		<UserSettingCategoryDrawer />
    </Grid>
}